"use client";

import React from "react";
var __jsx = React.createElement;
import { MIXPANEL_EVENTS } from "@lib/mixpanel/mixpanel.event-list";
import mixpanelService from "@lib/mixpanel/mixpanel.service";
import MuscleErrorPage from "@modules/flow-independent-pages/error-page/page";
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
export default function GlobalError(_ref) {
  let {
    error
  } = _ref;
  useEffect(() => {
    mixpanelService.trackEvent(MIXPANEL_EVENTS.Global.INTERRUPTION, {
      error: error
    });
    Sentry.captureException(error);
  }, [error]);
  return __jsx("html", null, __jsx("body", null, __jsx(MuscleErrorPage, {
    code: '500'
  })));
}